import { render, staticRenderFns } from "./VFieldCheckbox.vue?vue&type=template&id=56e5236a&"
import script from "./VFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./VFieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e5236a')) {
      api.createRecord('56e5236a', component.options)
    } else {
      api.reload('56e5236a', component.options)
    }
    module.hot.accept("./VFieldCheckbox.vue?vue&type=template&id=56e5236a&", function () {
      api.rerender('56e5236a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldCheckbox.vue"
export default component.exports